export class UserInfo {
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  UserInfo: {
    CountryCode: string;
    EmployeeId: string;
    Name: string;
    UserId: string;
  };
  modules: { Key: string, Value: string }[];
  roles: any[];
  countryCodes: string[];
  countrySelection: boolean;
}
